import React from "react";
import { Container, Paper, Typography } from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import { DataNotAvailable } from "../../../plchina/DataNotAvailable";



export const OperationsList = () => {

  if(localStorage.getItem("theme")==='2'){
    return(
      <DataNotAvailable/>
    )
  }


  return (
    <Container>
      <Typography variant="h4">Operations</Typography>
      <Paper>
        <MuiLink component={Link} to="operations/wet_leakage">
          <Typography variant="h6">Wet Leakage</Typography>
        </MuiLink>
        <MuiLink component={Link} to="operations/diode_test">
          <Typography variant="h6">Diode Test</Typography>
        </MuiLink>
        <MuiLink component={Link} to={"operations/visual_inspection"}>
          <Typography variant="h6">Visual Inspection</Typography>
        </MuiLink>
        <MuiLink component={Link} to={"operations/colorimeter"}>
          <Typography variant="h6">Colorimeter</Typography>
        </MuiLink>
        <MuiLink
          component={Link}
          to={"/operations/flash_details"}>
          <Typography variant="h6">Flash Details Verify UI</Typography>
        </MuiLink>
        {/* <MuiLink component={Link} to={"operations/intake/crate"}>
          <Typography variant="h6">Crate Intake</Typography>
        </MuiLink>
        <MuiLink component={Link} to={"operations/intake/unit"}>
          <Typography variant="h6">Unit Intake</Typography>
        </MuiLink> */}

        <MuiLink
          component={Link}
          to={"/operations/edge_upload"}>
          <Typography variant="h6">Edge Pinch Upload </Typography>
        </MuiLink>
        <MuiLink
          component={Link}
          to={"/operations/insulation_test"}>
          <Typography variant="h6">Insulation Test </Typography>
        </MuiLink>

        <MuiLink
          component={Link}
          to={"/operations/upload_cloud"}>
          <Typography variant="h6">Upload to LSDB Cloud </Typography>
        </MuiLink>
      </Paper>
    </Container>
  );
};
